
import { useContext } from "react";
import { ToastContext } from "@/context/ToastContext";

// Define allowed toast types
export type ToastType = "info" | "success" | "error" | "warning";

// Define the structure of each toast
export interface ToastProps {
  title?: string;
  description: string;
  action?: string;
  type?: ToastType;
  variant?: "default" | "destructive";
  id?: string;
}

// Simplified hook with better error handling
export const useToast = () => {
  const context = useContext(ToastContext);
  
  if (!context) {
    console.error("useToast: ToastContext not found");
    
    // Return a fallback implementation
    return {
      toast: () => null,
      toasts: [],
      removeToast: () => {}
    };
  }
  
  return {
    toast: (props: ToastProps) => context.addToast(props),
    toasts: Array.isArray(context.toasts) ? context.toasts : [],
    removeToast: context.removeToast
  };
};
